import React, { useState } from 'react';
import './styles.scss';
import colors from "../../../../src/styles/_colors.scss";
import { CustomDrawer } from '../CustomDrawer/index';
import { SupportForm } from '../SupportForm';


export const Supportbutton = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleClick = () => {
    setIsDrawerOpen(true);
  };

  const handleClose = () => {
    setIsDrawerOpen(false);
  };

  return (
    <div className="ticket-container">
      {/* 1. Verplaats onClick direct naar de button */}
      <button className="floating-button" onClick={handleClick}>
        <svg
          width="20"
          height="20"
          viewBox="1 2 23 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.108 8.00224C11.2842 7.50136 11.632 7.079 12.0898 6.80998C12.5475 6.54095 13.0857 6.4426 13.609 6.53237C14.1324 6.62213 14.607 6.89421 14.949 7.30041C15.2909 7.70661 15.4781 8.22072 15.4773 8.75168C15.4773 10.2506 13.2289 11 13.2289 11M13.2579 14H13.2679M13.108 19C17.8024 19 21.608 15.1944 21.608 10.5C21.608 5.80558 17.8024 2 13.108 2C8.4136 2 4.60802 5.80558 4.60802 10.5C4.60802 11.45 4.76387 12.3636 5.05139 13.2166C5.15959 13.5376 5.21369 13.6981 5.22345 13.8214C5.23309 13.9432 5.2258 14.0286 5.19568 14.1469C5.16517 14.2668 5.09782 14.3915 4.96312 14.6408L3.32746 17.6684C3.09415 18.1002 2.97749 18.3161 3.0036 18.4828C3.02634 18.6279 3.11177 18.7557 3.2372 18.8322C3.3812 18.9201 3.62532 18.8948 4.11356 18.8444L9.23459 18.315C9.38967 18.299 9.46721 18.291 9.53788 18.2937C9.6074 18.2963 9.65647 18.3029 9.72426 18.3185C9.79318 18.3344 9.87984 18.3678 10.0532 18.4345C11.0012 18.7998 12.0312 19 13.108 19Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      <CustomDrawer
        open={isDrawerOpen}
        onClose={handleClose}
        content={<SupportForm />}
      >
      </CustomDrawer>
    </div>
  );
};